import {Component, Input, Output, forwardRef, EventEmitter, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';

import {AbstractFieldClass} from '../abstract-field.class';

import {DirectoryService} from '../../../services/directory.service';
import {PhoneTransformer} from '../../../services/transformer.service';
import {ConstantsService} from '../../../services/constants.service';

declare const swal: any;
declare const toastr: any;

@Component({
    selector: 'emergency-contacts-field',
    templateUrl: './emergency-contacts-field.component.html',
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => EmergencyContactsFieldComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => EmergencyContactsFieldComponent), multi: true}
    ]
})
export class EmergencyContactsFieldComponent extends AbstractFieldClass implements OnInit {
    @Input('value') _value = [];
    @Input() users = [];
    @Input() objectId: number;
    @Input() propertyName: string;
    @Input() title: string;
    @Input() labelClass = 'col-md-3';
    @Input() contentClass = 'col-md-9';
    @Input('class') valueClass = '';
    @Input() hideEmptyArrayLabel = false;

    private primaryPhoneIndex: number;
    private originPrimaryPhoneIndex: number;

    constructor(public directoryService: DirectoryService) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.getCurrentPrimaryState();
        setTimeout(() => {
            if(!this.value)
                this.value = [];
            this.sortContacts();
        }, 0);
    }

    addNew(): void {
        const isFirst = this.value.length === 0;
        this.value.push({
            name: '',
            phone: '',
            email: '',
            relation: '',
            isPrimary: false,
            note: '',
            user: this.propertyName == 'user' ? null : undefined
        });

        if (isFirst) {
            this.getCurrentPrimaryState();
        }

        this.propagateChange(this.value);
        this.editModeOn();
    }

    public delete(index): void {
        swal(ConstantsService.getSwalConfig('Delete Contact'), () => {
            this.remove(index);
            this.apply();
        });
    }

    public updateProperty(propertyName, value, index): void {
        this.value[index][propertyName] = value;
        this.propagateChange(this.value);
    }

    public validateValue(event) {
        return event.charCode >= 48 && event.charCode <= 57;
    }

    private updatePrimary(index): void {
        if (!this.value.length) return;
        this.resetPrimaryState();
        this.value[index].isPrimary = true;
        this.propagateChange(this.value);
    }

    private resetPrimaryState(): void {
        this.value.forEach((item) => item.isPrimary = false);
    }

    private getCurrentPrimaryState(): void {
        if (this.value.length === 1) {
            this.primaryPhoneIndex = 0;
            this.originPrimaryPhoneIndex = 0;
            this.updatePrimary(0);
            return;
        }
        for (let i = 0; i < this.value.length; i++) {
            if (this.value[i].isPrimaryPhone) {
                this.primaryPhoneIndex = i;
                this.originPrimaryPhoneIndex = i;

                return;
            }
        }
    }

    apply(): void {
        if(this.dataIsValid()) {
            if(this.propertyName)
                this.value.forEach(v => {
                    delete v.userName;
                    if(this.propertyName == 'suite') {
                        v[this.propertyName] = this.objectId;
                        delete v.user;
                    } else if(this.propertyName == 'user')
                        delete v.suite;
                });
            this.sortContacts();

            super.apply();
            this.getCurrentPrimaryState();
        }
    }

    copyValue(): void {
        super.copyValue();
    }

    validator(value: any): boolean {
        return undefined;
    }

    private dataIsValid() {
        let valid = true;
        let hasEmpty = false;
        this.value.forEach((item) => {
            if(!item.name && !item.phone && !item.email && !item.relation && !item.note) {
                valid = false;
                hasEmpty = true;
            } else if(item.email && !this.emailIsValid(item.email)) {
                toastr.warning(`Email ${item.email} is invalid.`);
                valid = false;
            }
        });
        if(hasEmpty)
            toastr.warning('At least one field per item must be field.');
        return valid;
    }

    emailIsValid(email) {
        return email.match('[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?');
    }

    cancel(index?) {
        if (this.editOnly) {
            this.value.splice(index, 1);
            if (!this.value.some(p => p.isPrimaryPhone) && this.value.length) {
                this.value[0].isPrimaryPhone = true;
            }
        } else {
            super.cancel();
        }
    }

    sortContacts() {
        const index = this.value.findIndex(v => v.isPrimary);
        if(index != -1 && index != 0) {
            const temp = JSON.parse(JSON.stringify(this.value[0]));
            this.value[0] = this.value[index];
            this.value[index] = temp;
        }
    }

    remove(index) {
        if (index === 0 && this.value[index].isPrimary && this.value[1]) {
            this.updatePrimary(1);
        }
        if (this.value[index].isPrimary) {
            this.updatePrimary(0);
        }
        this.value.splice(index, 1);
        this.propagateChange(this.value);
        if(this.value.length < 1)
            this.apply();
    }

    preparePhoneForInput(data: any) {
        if(data.phone.match('^[0-9]+$'))
            return PhoneTransformer.phoneToString(data.phone);
        else
            return data.phone.substr();
    }
}




// WEBPACK FOOTER //
// /app/src/app/components/fields/emergency-contacts-field/emergency-contacts-field.component.ts